import type { I18TParams } from '@/i18n.ts';
import Validator from '@/modules/common/utils/validator.ts';

export type CounterpartyLegalFields = {
  name: string;
  inn: string;
  kpp: string;
  ogrn: string;
  okpo: string;
  okato: string;
};

export type CounterpartyLegalFieldErrors = Partial<Record<keyof CounterpartyLegalFields, string | I18TParams>>;

export function validateCounterpartyLegalFields(
  fields: CounterpartyLegalFields,
  {
    requireName = false,
    skipFormat = false,
    validateKpp = true,
    validateOkpoOkato = true,
  }: {
    requireName?: boolean;
    skipFormat?: boolean;
    validateKpp?: boolean;
    validateOkpoOkato?: boolean;
  } = {}
): CounterpartyLegalFieldErrors {
  const errors: CounterpartyLegalFieldErrors = {};

  if (requireName) {
    const nameError = Validator.required(fields.name.trim());
    if (nameError) {
      errors.name = nameError;
    }
  }

  if (skipFormat) {
    return errors;
  }

  const innError = Validator.inn(fields.inn);
  if (innError) {
    errors.inn = innError;
  }

  if (validateKpp) {
    const kppError = Validator.kpp(fields.kpp);
    if (kppError) {
      errors.kpp = kppError;
    }
  }

  const ogrnError = Validator.ogrn(fields.ogrn);
  if (ogrnError) {
    errors.ogrn = ogrnError;
  }

  if (validateOkpoOkato) {
    const okpoError = Validator.okpo(fields.okpo);
    if (okpoError) {
      errors.okpo = okpoError;
    }

    const okatoError = Validator.okato(fields.okato);
    if (okatoError) {
      errors.okato = okatoError;
    }
  }

  return errors;
}
